import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withWidth from '@material-ui/core/withWidth';
import { HubConnectionBuilder } from "@microsoft/signalr";
import IdleTimer from 'react-idle-timer'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
// import { useBeforeunload } from 'react-beforeunload';
import Typography from '@material-ui/core/Typography';

import initiateConnection from './actions/connection_actions';
import getProfileFetch from './actions/profile_actions';
import userActions from './actions/user_actions';
import memberActions from './actions/member_actions';
import unreadActions from './actions/unread_message_actions';
import windowActions from './actions/window_actions';
import LoginPage from './components/LoginPage';
import MainSideBar from './components/MainSideBar';
import MainMenu from './components/MainMenu';
import { logoutUser } from './actions/logout_actions';

import './index.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.idleTimer1 = null;
        this.timeLeftInterval = null;
        this.networkTimeLeftInterval = null;
        this.state = {
            openIsActiveDialog: false,
            openUpdateStatusDialog: true,
            isDisconnected: false,
        };
        this.connection = new HubConnectionBuilder()
            .withUrl("/notifications", { accessTokenFactory: () => localStorage.token })
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: retryContext => {
                    return Math.random() * 10000;
                }
            })
            .build();
    }

    flashNotification = (protocol, action, params) => {
        console.log("flash protocol called");
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams != "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };

    
    componentDidMount = () => { 
        this.handleConnectionChange();
        this.props.getProfileFetch();
        console.log("App - unreads");
        this.props.getUnreadMessagesFromDb(); 
        console.log("Unreads from App...", this.props.unreadMessages);
        this.connection
            .start()
            .then(() => {
                console.log("Hub connected successfully");
                console.log("connectionId: ", this.connection.connectionId); // ID changes on reload
                this.props.initiateConnection(this.connection);
                console.log(this.connection);

                this.connection.onclose(error => { // reconnects to hub after a disconnect
                    console.log("Connection closed! Reason: " + error); //
                    setTimeout(function () {
                        this.connection.start();
                    }.bind(this), 5000);
                });

                setInterval(
                    () => {
                        this.connection.invoke('SendUserActivePing', this.props.profile.id).catch(function (err) {
                        return console.error("Pinging Error " + err.toString());
                        });
                    }, 30000);
            }).then(() => {
                this.connection.on('UpdateUser', (user => {
                    this.props.fetchMember();
                    this.props.getProfileFetch();
                }));
                this.connection.on('SetUserStatus', (message => {
                    console.log("user active " + message);
                    if (message.indexOf('disconnected') >= 0) {
                        var updatedUser = { ...this.props.profile };
                        this.props.updateProfile(updatedUser);
                    }
                }));
                this.connection.on('NewMessage', (message => {/////////////////////////////////////////////////////////////////////////////////
                    
                    // play audio notification
                    if (message.payload.userId !== this.props.profile.id) {
                        console.log("play audio");
                        this.audio = new Audio('./light.mp3');
                        //this.audio.load();
                        //this.playAudio();
                        this.audio.play();
                    }
                    
                    
                    console.log("New message recieved! App JS");
                    console.log(message);
                    if (message.payload.userId !== this.props.profile.id) {
                        this.props.updateUnread(message);
                        if (this.props.profile.hasOwnProperty('id')) { // current signed in user
                            var l = [];
                            for (var property in this.props.unreadMessages) {

                                if (property.includes("Object")) {
                                    continue;
                                }
                                if (this.props.unreadMessages[property]) {
                                    l.push(property);
                                }
                            }
                            console.log(l)
                            this.props.setUnreadIds(l);
                        } else {
                            console.log("Don't update since the user isn't logged in");
                        }
                    }
                }));
            })
            //.then(() => {
            //    //this.isuserActiveTest();
            //    const webPing = setInterval(
            //        () => {
            //            fetch('//google.com', {
            //                mode: 'no-cors',
            //            })
            //                .then(() => {
            //                    console.log("inside webping");
            //                    this.setState({ isDisconnected: false }, () => {
            //                        //this.isuserActiveTest();
            //                        return clearInterval(webPing)
            //                    });
            //                }).catch(() => { console.log("inside webping disconnect"); this.setState({ isDisconnected: true }); })
            //        }, 3000);
            //})
            .catch(err => console.error(err.toString()));
        
        window.addEventListener("beforeunload", this.unload);
        window.addEventListener('online', this.handleConnectionChange);
        window.addEventListener('offline', this.handleConnectionChange);
        
        var sheet = document.createElement('style');
        document.body.appendChild(sheet);
        sheet.innerHTML = '@media (max-width:767px){body{padding-right:0!important}.MuiOutlinedInput-multiline-327{padding:5px!important}.MuiInputBase-root-269{line-height:1.4em!important;padding:5px!important}.MuiDialog-paper-5{margin:5px!important}.MuiTypography-title-227{font-weight:600;font-size:20px}.emoji-mart-scroll{height:150px}.emoji-mart-preview{position:relative;height:60px}a#flashNotification{display:block;position:fixed;bottom:-1px;right:-1px;z-index:-1;opacity:0;width:1px;height:1px}}';
    }
    
    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.unload);
        window.removeEventListener('online', this.handleConnectionChange);
        window.removeEventListener('offline', this.handleConnectionChange);
    }
    
    handleConnectionChange = () => {
        const condition = navigator.onLine ? 'online' : 'offline';
        console.log("network condition: ", condition);
        if (condition === 'online') {
            const webPing = setInterval(
                () => {
                    fetch('//google.com', {
                        mode: 'no-cors',
                    })
                        .then(() => {
                            this.setState({ isDisconnected: false }, () => {
                                return clearInterval(webPing)
                            });
                        }).catch(() => this.setState({ isDisconnected: true }))
                }, 2000);
            return;
        }
        return this.setState({ isDisconnected: true }, () => { this.networkStartTimer(); });
    };
    
    unload = (ev) => {
        console.log("Caught unload");
        if (localStorage.getItem('justLoggedIn')) {
            console.log("Removed blocked");
            localStorage.removeItem("justLoggedIn");
        } else {
            if (this.props.profile.hasOwnProperty('id')) {
                var updatedUser = { ...this.props.profile };
                updatedUser["status"] = "Done";
                updatedUser["inOffice"] = false;
                updatedUser["stamp"] = "validLogout";
                this.props.updateProfile(updatedUser);
                this.props.updateLastSeen();
            } else {
                console.log("Don't update since the user isn't logged in");
                return ev;
            }
            console.log("Removed token");
            localStorage.removeItem("token");
            this.props.setChatDisplay(false);
            //
            if (window.open("", "ChatBoxWindow", "") !== null && window.open("", "Bulletin") !== null && window.open("", "MakeAnnouncement") !== null && window.open("", "Announcement") !== null && window.open("", "UserManager") !== null && window.open("", "GroupManager") !== null) {
                window.open("", "ChatBoxWindow", "").close();
                window.open("", "Bulletin","").close();
                window.open("", "MakeAnnouncement", "").close();
                window.open("", "Announcement", "").close();
                window.open("", "UserManager", "").close();
                window.open("", "GroupManager", "").close();
            }
            //
        }
    }
    
    /*
    
    // Chat Window Styling
    jss675 {padding 0px}
    jss673 {padding 18.5px 14px}
    jss281 {resize none; padding 0px}
    jss279 {font inherit; color currentcolor...}
    
    MuiOutlinedInput-inputMultiline-331 {padding 0px}
    MuiOutlinedInput-input-329 {padding 18.5px 14px}
    MuiInputBase-inputMultiline-281 {resize none; padding 0px}
    MuiInputBase-input-279 {font inherit; color currentcolor...}
    
    
    
    // Body
      @media(max-width: 767px) {
      body {
        padding-right: 0!important
      }
        .MuiOutlinedInput-multiline-327 {
        padding: 5px!important
      }
        .MuiInputBase-root-269 {
        line-height: 1.4em!important;
        padding: 5px!important
      }
        .MuiDialog-paper-5 {
        margin: 5px!important
      }
        .MuiTypography-title-227 {
        font-weight: 600;
        font-size: 20px
      }
        .emoji-mart-scroll {
        height: 150px
      }
        .emoji-mart-preview {
        position: relative;
        height: 60px
      }
      a#flashNotification {
        display: block;
        position: fixed;
        bottom: -1px;
        right: -1px;
        z - index: -1;
        opacity: 0;
        width: 1px;
        height: 1px
      }
    }
    
     
    
    
    
    
      @media(max-width: 767px) {
      body {
        padding-right: 0!important
      }
        .jss327 {
        padding: 5px!important
      }
        .jss269 {
        line-height: 1.4em!important;
        padding: 5px!important
      }
        .jss5 {
        margin: 5px!important
      }
        .jss227 {
        font-weight: 600;
        font-size: 20px
      }
        .emoji-mart-scroll {
        height: 150px
      }
        .emoji-mart-preview {
        position: relative;
        height: 60px
      }
      a#flashNotification {
        display: block;
        position: fixed;
        bottom: -1px;
        right: -1px;
        z - index: -1;
        opacity: 0;
        width: 1px;
        height: 1px
      }
    }
    
    */

    onIdle1 = (e) => {
        console.log('user is idle1', e);
        console.log('last active1', this.idleTimer1.getLastActiveTime()); //Returns the Timestamp the user was last active
        if (!this.state.openIsActiveDialog && localStorage.token) {
            this.setState({ openIsActiveDialog: true });
            this.startTimer();
        }
    };

    handleIsActiveDialogOpen = () => {
        this.setState({ openIsActiveDialog: true });
    };

    handleIsActiveDialogClose = () => {
        if (this.state.timeLeftInterval != null) {
            clearInterval(this.state.timeLeftInterval);
        }
        this.setState({ openIsActiveDialog: false });
    };
    
    handleUpdateStatusDialogOpen = () => {
        this.setState({ openUpdateStatusDialog: true });
    };

    handleUpdateStatusDialogClose = () => {
        this.setState({ openUpdateStatusDialog: false });
    };

    handleNetworkLossReload = () => {
        setTimeout(() => window.location.reload(), 100);
    };

    
    startTimer = () => {
        var timeLeft = 30;
        //const now = Date.now();
        //const timeBeforeForcedLogout = 0.5 * 60 * 60 * 1000;
        //var updatedUser = { ...this.props.profile };
        var downloadTimer = setInterval(function () {
            //document.getElementById("countdown").innerHTML = timeLeft;
            timeLeft -= 1;
            if (timeLeft < 0) {
                if (this.state.openIsActiveDialog) {
                    this.setState({ openIsActiveDialog: false });
                    this.handleIsActiveDialogClose();

                    var updatedUser = { ...this.props.profile };
                    updatedUser["Status"] = "Done";
                    updatedUser["inOffice"] = false;
                    this.props.updateProfile(updatedUser);

                    this.flashNotification('teamx', 'flashstop');
                    localStorage.removeItem("token");
                    this.props.logoutUser();
                    this.props.setChatDisplay(false);
                    setTimeout(() => window.location.reload(), 500);
                }
                clearInterval(downloadTimer);
            }
            
        }.bind(this), 1000);

        this.setState({ 'timeLeftInterval': downloadTimer });
        //
        if (window.open("", "ChatBoxWindow") !== null && window.open("", "Bulletin") !== null && window.open("", "MakeAnnouncement") !== null && window.open("", "Announcement") !== null && window.open("", "UserManager") !== null && window.open("", "GroupManager") !== null) {
            window.open("", "ChatBoxWindow", "").close();
            window.open("", "Bulletin", "").close();
            window.open("", "MakeAnnouncement", "").close();
            window.open("", "Announcement", "").close();
            window.open("", "UserManager", "").close();
            window.open("", "GroupManager", "").close();
        }
        //
    };
    
    
    networkStartTimer = () => {
        var timeLeft = 10;
        var networkDownloadTimer = setInterval(function () {
            document.getElementById("networkCountdown").innerHTML = timeLeft;
            timeLeft -= 1;
            if (timeLeft < 0) {
                if (this.state.isDisconnected) {
                    this.flashNotification('teamx', 'flashstop');
                    setTimeout(() => window.location.reload(), 500);
                }
                clearInterval(networkDownloadTimer);
            }
        }.bind(this), 1000);
        this.setState({ 'networkTimeLeftInterval': networkDownloadTimer });
        //
        if (window.open("", "ChatBoxWindow") !== null && window.open("", "Bulletin") !== null && window.open("", "MakeAnnouncement") !== null && window.open("", "Announcement") !== null && window.open("", "UserManager") !== null && window.open("", "GroupManager") !== null) {
            window.open("", "ChatBoxWindow", "").close();
            window.open("", "Bulletin", "").close();
            window.open("", "MakeAnnouncement", "").close();
            window.open("", "Announcement", "").close();
            window.open("", "UserManager", "").close();
            window.open("", "GroupManager","").close();
        }
        //
    };
    
    render() {
        console.log("connection: ", this.connection);
        console.log("connectionId: ", this.connection.connectionId);
        console.log("connection.state: ", this.connection.state); // Connecting, Connected, Reconnecting, or Disconnected
        console.log("connection.connectionState: ", this.connection.connectionState); // Connecting, Connected, Reconnecting, or Disconnected
        let updateStatusDialog;
        if (this.props.profile.status === "Disconnected") {
            updateStatusDialog =
                <Dialog
                    open={this.state.openUpdateStatusDialog}
                    aria-labelledby="form-dialog-title"
                    style={{ margin: '5px !important' }}
                    PaperProps={{ style: { minWidth: '190px' } }}
                >
                    <DialogTitle id="form-dialog-title" style={{ paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>You've Disconnected!</DialogTitle>
                    <DialogContent style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '10px', fontSize: '11px' }}>
                        Please update your status when you have reconnected.
          </DialogContent>
                    <DialogActions style={{ margin: '0px' }}>
                        <Button onClick={this.handleUpdateStatusDialogClose} color="primary" style={{ margin: '0px', fontSize: '10px' }}>
                            OK
            </Button>
                    </DialogActions>
                </Dialog>;
        } else {
            updateStatusDialog = <div></div>;
        }

        let networkLossDialog =
            <Dialog
                open={true}
                aria-labelledby="form-dialog-title"
                style={{ margin: '5px !important' }}
                PaperProps={{ style: { minWidth: '190px' } }}
            >
                <DialogTitle id="form-dialog-title" style={{ paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>
                    <Typography style={{ fontSize: '14px', fontWeight: 'bold' }}>You've Disconnected!</Typography>
                </DialogTitle>
                <DialogContent style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '10px', fontSize: '11px' }}>
                    This page will refresh in <span id="networkCountdown"></span> seconds. Please check your internet connection.
                </DialogContent>
            </Dialog>;
        {/*
      <Dialog
        open={true}
        aria-labelledby="form-dialog-title"
        style={{ margin: '5px !important' }}
        PaperProps={{ style: { minWidth: '190px' } }}
      >
        <DialogTitle id="form-dialog-title" style={{ paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>
          <Typography style={{ fontSize: '14px', fontWeight: 'bold' }}>You've Disconnected!</Typography>
        </DialogTitle>
        <DialogContent style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '10px', fontSize: '11px' }}>
          Please click OK to reload and check your internet connection.
        </DialogContent>
        <DialogActions style={{ margin: '0px', padding: '0px' }}>
          <Button onClick={this.handleNetworkLossReload} color="primary" style={{ marginRight: '5px', marginBottom: '5px', fontSize: '10px' }}>
            OK
          </Button>
        </DialogActions>
      </Dialog>;
      */}

        const { width } = this.props;
        return (
            <div>
                {/*this.state.isDisconnected && networkLossDialog && (this.props.setDisconnected(true) || true)*/}
                {this.state.isDisconnected && networkLossDialog}
                <IdleTimer
                    ref={ref => { this.idleTimer1 = ref }}
                    element={document}
                    onIdle={this.onIdle1}
                    debounce={250}
                    timeout={4 * 60 * 60 * 1000} // 4 hours
                    //timeout={10000} // 10 seconds
                />
                <Dialog
                    open={this.state.openIsActiveDialog}
                    aria-labelledby="form-dialog-title"
                    style={{ margin: '5px !important' }}
                    PaperProps={{ style: { minWidth: '190px' } }}
                >
                    <DialogTitle id="form-dialog-title" style={{ paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>
                        <Typography style={{ fontSize: '14px', fontWeight: 'bold' }}>Still Active?</Typography>
                    </DialogTitle>
                    <DialogContent style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '10px', fontSize: '11px' }}>
                        Please respond within <span id="countdown"></span> seconds.
                    </DialogContent>
                    <DialogActions style={{ margin: '0px', paddingTop: '0px' }}>
                        <Button onClick={this.handleIsActiveDialogClose} color="primary" style={{ margin: '0px', fontSize: '10px' }}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                {updateStatusDialog}
                <LoginPage />
                <MainSideBar className="test" />
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    logoutUser: () => dispatch(logoutUser()),
    initiateConnection: (connection) => dispatch(initiateConnection['INITIATE_CONNECTION'](connection)),
    getProfileFetch: () => dispatch(getProfileFetch['LOAD_PROFILE']()),
    fetchMember: () => dispatch(memberActions['FETCH_MEMBERS']()),
    updateUnread: (message) => dispatch(userActions['SET_UNREAD_MESSAGE'](message)),
    setDisconnected: (bool) => dispatch(userActions['SET_DISCONNECTED'](bool)),
    //updateLastSeen: () => dispatch(userActions['UPDATE_LAST_SEEN']()),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp)),
    updateStamp: () => dispatch(userActions['UPDATE_STAMP']()),
    setChatDisplay: shouldDisplay => dispatch(windowActions['SET_CHAT_DISPLAY'](shouldDisplay)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    updateProfile: user => dispatch(getProfileFetch['UPDATE_PROFILE'](user)),
    setUnreadIds: unreadIds => dispatch(unreadActions['SET_UNREAD_IDS'](unreadIds)),
    getUnreadMessagesFromDb: () => dispatch(unreadActions['GET_UNREAD_IDS']()),
})

function mapStateToProps(state) {
    return {
        profile: state.profile,
        shouldAllowWindowAutoClose: state.shouldAllowWindowAutoClose,
        unreadMessages: state.unreadMessages,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
        //shouldDisplayChat: state.shouldDisplayChat,
    };
}

App.propTypes = {
    width: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(App));

//export default connect(null, mapDispatchToProps)(App);


/*

Next Phase:
-Prompt user to update status when back by time is reached
-emoji :id: shortcut [ChatBoxCompose.js]
-bring chatbox up using focus
-Remove white bar in opened windows
-opens new chat window when double click after refreshing, even if chat is already opened (don't log out or refresh)
-when logout, auto set status to unavailable & close all opened windows (don't log out)
-close all open windows when logout or close memberList (don't log out)
-create a callback to parent component (sideMenuBar) losing MainMenu closes Bulletin window
-add spinner for save button (userManager and groupManager)
-when user is not back by their specified away time, dialog pops up to change status [UserInfo.js]
-away time formating from time picker is 24hr but need to display 12hr AM/PM [UserInfo.js; handleChange function]
-announcements
-connect to odyssey API for bulletin
-update bulletin with API calls throughout the day + motivational quote API
-permissions to search all conversations for admin
-"Person is typing..."


==== Features ====
-bulletin board
  -display sales progress & goals
  -motivational quotes API
-User manager
  -create a new user (name, extension, password, email)
  -set name, extension, password, permissions
  -change existing users
-Group mananger
  -create a group
  -add a member to group
  -remove a member from a group
  -list of all groups and their members
Login
  -user logs in via email/password
  -if enter invalid email/password, error message appears
  -when login successful, user will stay logged in for x amt of days
  -user can logout
  -press enter to login

Browser sidebar (MatterMost)
  -Expand1: list of all members, showing their status, hover for phone numbers
  -Expand2: Group Messages/Channels & Direct messages
    -unread messages (number of unread messages in browser tab & light up taskbar icon)
    -users' status
    -number people in the group
    -List group members' names... OR group name that they can create
    -hover over message to expose x to close the chat

Pop out member list
  -look & function same as SM list
  -displays name, extension, in/out of office, away message clock icon, who is oncall via MM logo icon
  -hover over name for name and phone numbers
  -pop out button should be bottom of left side bar
  -show & change user's status on pop-out list

User status + Away message
  -user selects from 4 different statuses next to user's name
  -user can enter in away message + away time (optional)
  -away message includes a text box and a time picker to select what time they will be back (how to handle when some people say ASAP?)
  -when that time comes, show pop up alert propmpting user to update status (will users still receive messages while alert is not clicked?)
  -everytime they login, should status be available?
  -when change status, should be reflected in list
  -away message -> cancel: doesn't change status to busy
                -> no message: unbold, black font color name
               -> ok: unbold, black font color name, clock symbol, message & time required
  -when submit away mssg & back time, user will be prompted to change their status at the time they inputed
  
Edit profile
  -user can edit their profile (name, address, phone numbers, email, extension) (email address that they login with)
  -user can edit their work schedule (should this be time pickers too?)

On-call schedule
  -only available to those with group/role Admin
  -select on-call schedule for each company (MarketMaps, GBBIS, etc.)
  -persist on-call schedule from previous day
  -emails on-call schedule to specified recipients 
  -specified recipients vary between each company (persist the email recipients for each company)
  -what if no email recipients are selected and press "send email"?

Chat messaging
  -chat instant messaging box by double clicking user's name on pop-out list
  -only one chat box; multiple tabs for multiple chats
  -chat messaging window in browser tab
  -lists direct messages + group direct messages, private channels, public channels
  -emojis

User Manage + Manage Groups
  -UI to add a new employee to TeamX
  -Set up their name, phone extension, password, email, user permissions (Allow the ability to manage users, Allow the ability to change the on call schedule, Allow the ability to view log files)
  -UI for adding a member to a group (ex: Admin, Developers, Sales, etc.)

View progress and goals
  -displays company sales via percentage bars, dollar amt goal, time frame, this year, last year
  -motivational quote
  -business days left (There is 1 day left in the week, There are 16 days left in the month, etc.)
  


App
 |
 | __ LoginPage
 |
 | __ MainSideBar
 |     |
 |     | __ UserHub (logout, main menu, bulletin, user/group manager)
 |     |     |
 |     |     | __ UserInfo (user's name, avatar, status symbol, change status, add away message)
 |     |     |
 |     |     | __ MainMenu (options: edit profile/schedule, select on-call schedule if admin role, logout)
 |     |           |
 |     |           | __ Profile (edit your profile/schedule)
 |     |           |
 |     |           | __ Bulletin
 |     |           |
 |     |           | __ OnCallScheduleList (on hold)
 |     |                 |
 |     |                 | __ OnCallScheduleItem (on hold)
 |     |
 |     | __ MemberList
 |           | 
 |           | __ MemberListItem
 |           |
 |           | __ ChatBoxTabsWindow (fetches messages array and passes it to MessageList which passes it to MessageListItem)
 |                  |
 |                  | __ ChatBoxMessageList
 |                  |     |
 |                  |     | __ ChatBoxMessageListItem
 |                  |
 |                  | __ ChatBoxCompose (adds message obj to messages array)
 |     





 |     | __ DirectMessageList (Tab2)
 |           |
 |           | __DirectMessageListItem
 |     
 | __ WideChatWindow
 |     |
 |     | __ WideChatTopBar
 |     |
 |     | __ WideChatMessageDisplay
 |     |     |
 |     |     | __ WideChatMessageDisplayItem
 |     |
 |     | __ WideChatMessageCompose
 */


// WEBPACK FOOTER //
// ./src/App.js